import {Component, OnInit} from '@angular/core';
import {NotifierService} from "angular-notifier";
import {ServiceService} from "../../../service.service";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import * as XLSX from "xlsx";


// This is for the range date picker
const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one &&
  two &&
  two.year === one.year &&
  two.month === one.month &&
  two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two
    ? false
    : one.year === two.year
    ? one.month === two.month
      ? one.day === two.day
        ? false
        : one.day < two.day
      : one.month < two.month
    : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two
    ? false
    : one.year === two.year
    ? one.month === two.month
      ? one.day === two.day
        ? false
        : one.day > two.day
      : one.month > two.month
    : one.year > two.year;

// End  range date picker

@Component({
  selector: 'app-check-return-orders',
  templateUrl: './check-return-orders.component.html',
  styleUrls: ['./check-return-orders.component.css']
})
export class CheckReturnOrdersComponent implements OnInit {
  // This is for the range date picker
  hoveredDate: NgbDateStruct;

  fromDate: NgbDateStruct = null;
  toDate: NgbDateStruct = null;
  keyword = 'name';
  rows = [];
  allUsers: any[];
  phoneDetailsJsonArray: any[];
  currentSelectedEmployeeName: any = "All";
  currentSelectedEmployeeEmail: any = "All";
  totalOrders: any = 0;
  pendingOrdersCount: any = 0;
  dispatchedOrdersCount: any = 0;
  confirmedOrdersCount: any = 0;
  deliveredOrdersCount: any = 0;
  returnedOrdersCount: any = 0;
  warrantyOrdersCount: any = 0;
  canceledOrdersCount: any;
  private notifier: NotifierService;

  constructor(private serviceClass: ServiceService, private activatedRoute: ActivatedRoute, private router: Router, notifier: NotifierService) {
    this.notifier = notifier;
  }

  ngOnInit(): void {
    window.scroll(0, 0);

    this.serviceClass.getAllEmployees().subscribe(
      data => {
        let employeeData = [{email: "All", name: "All"}];

        for (let item of data) {
          employeeData.push({name: item["name"], email: item["email"]});
        }
        this.allUsers = employeeData;
      }
    );

    this.serviceClass.getAllItems().subscribe(
      data => {
        this.phoneDetailsJsonArray = data;
      }
    );
  }

  exportAsExcel(): void {
    let currentTimeAndDate = new Date();
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.formatDate(currentTimeAndDate) + " - Return Orders Checker.xlsx");
  }

  formatTime(dateAndTime: any) {
    let newDate = new Date(dateAndTime);
    return newDate.getFullYear() + "-" + (newDate.getMonth() + 1) + "-" + newDate.getDate() + " " + newDate.getHours() + ":" + newDate.getMinutes();
  }

  formatDate(dateAndTime: any) {
    let newDate = new Date(dateAndTime);
    return newDate.getFullYear() + "-" + (newDate.getMonth() + 1) + "-" + newDate.getDate();
  }

  getFormattedDateOfDelivery(dateAndTime: any) {
    let newDate = new Date(dateAndTime);
    return newDate.toISOString().split('T')[0];
  }

  getTheFirstCharacter(empName: any) {
    return empName.substr(0, 1).toUpperCase();
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }


  resetThePage() {
    window.location.reload();
  }

  onDateChange(date: NgbDateStruct) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && after(date, this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered = date =>
    this.fromDate &&
    !this.toDate &&
    this.hoveredDate &&
    after(date, this.fromDate) &&
    // tslint:disable-next-line:semicolon
    before(date, this.hoveredDate);
  isInside = date => after(date, this.fromDate) && before(date, this.toDate);
  isFrom = date => equals(date, this.fromDate);
  isTo = date => equals(date, this.toDate);

  selectedEmployee(jsonValue: any) {
    this.currentSelectedEmployeeName = jsonValue["name"];
    this.currentSelectedEmployeeEmail = jsonValue["email"];
  }

  dateFormatter(dateString: any) {
    let newDate = new Date(dateString);
    return newDate.getFullYear() + "-" + (newDate.getMonth() + 1) + "-" + newDate.getDate();
  }

  timeFormatter(dateString: any) {
    let newDate = new Date(dateString);
    return newDate.getHours() + ":" + newDate.getMinutes() + ":" + newDate.getSeconds();
  }

  routeToSingleOrderPage(orderNumber: any) {
    this.router.navigate(['/admin/order_details'], {queryParams: {orderId: orderNumber}});
  }

  getJsonObjectFromItemDetails(id: any) {
    for (let item of this.phoneDetailsJsonArray) {
      if (item["deviceId"] == id) {
        return item;
      }
    }
  }

  getItemName(id: any) {
    let deviceArray = this.getJsonObjectFromItemDetails(id);
    if (deviceArray != undefined) {
      return deviceArray["name"];
    } else {
      return "No Item";
    }
  }

  updateOrderAndConfirmedCounts() {
    this.pendingOrdersCount = 0;
    this.dispatchedOrdersCount = 0;
    this.confirmedOrdersCount = 0;
    this.deliveredOrdersCount = 0;
    this.canceledOrdersCount = 0;
    this.returnedOrdersCount = 0;
    this.warrantyOrdersCount = 0;

    this.totalOrders = this.rows.length;
    for (let item of this.rows) {
      if (item["deliveryStatus"] == 'pending') {
        this.pendingOrdersCount += 1;
      } else if (item["deliveryStatus"] == 'confirmedWithCOD' || item["deliveryStatus"] == 'confirmed') {
        this.confirmedOrdersCount += 1;
      } else if (item["deliveryStatus"] == 'dispatched') {
        this.dispatchedOrdersCount += 1;
      } else if (item["deliveryStatus"] == 'delivered') {
        this.deliveredOrdersCount += 1;
      } else if (item["deliveryStatus"] == 'canceled') {
        this.canceledOrdersCount += 1;
      } else if (item["deliveryStatus"] == 'return') {
        this.returnedOrdersCount += 1;
      } else {
        this.warrantyOrdersCount += 1;
      }
    }
  }

  getLabelType(deliveryStatus: any) {
    if (deliveryStatus == "pending") {
      return "label-primary pending";
    } else if (deliveryStatus == "confirmed") {
      return "label-info confirmed";
    } else if (deliveryStatus == "dispatched") {
      return "label-warning dispatched";
    } else if (deliveryStatus == "delivered") {
      return "label-success delivered";
    } else if (deliveryStatus == "return") {
      return "label-danger return";
    } else if (deliveryStatus == "canceled") {
      return "label-warning canceled";
    } else if (deliveryStatus == "warrenty") {
      return "label-secondary warrenty";
    }
  }

  updateTable() {
    this.totalOrders += 0;
    this.confirmedOrdersCount += 0;
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0');
    let yyyy = today.getFullYear();

    let tempFromDate = null;
    let tempToDate = null;

    if (this.fromDate != null) {
      let fromDateObj: Date = new Date(this.fromDate.year + "-" + this.fromDate.month + "-" + this.fromDate.day);

      fromDateObj.setDate(fromDateObj.getDate() - 1);
      tempFromDate = fromDateObj.getFullYear() + "-" + (fromDateObj.getMonth() + 1) + "-" + fromDateObj.getDate();

      if (this.toDate == null) {
        tempToDate = this.fromDate.year + "-" + this.fromDate.month + "-" + this.fromDate.day;
      } else {
        tempToDate = this.toDate.year + "-" + this.toDate.month + "-" + this.toDate.day;
      }
    }

    let temporaryOrderNumberArray = [];
    this.rows = [];
    this.serviceClass.getReturnedOrdersBasedDate(this.currentSelectedEmployeeEmail, tempFromDate, tempToDate).subscribe(
      data => {
        for (let item of data) {
          if (temporaryOrderNumberArray.includes(item["orderNumber"])) {
          } else {
            temporaryOrderNumberArray.push(item["orderNumber"]);
            let tempValue = {
              date: item["date"],
              orderId: item["orderNumber"],
              orderNumber: item["orderNumber"],
              COD: item["COD"],
              dispatchedDate: "",
              returnDate: item["dateAndTime"],
              confirmAgent: "",
              reasonToReturn: item["reasonToReturn"],
              checkBy: item["checkBy"],
              mistakeBy: item["mistakeBy"],
              authorizedBy: item["authorizedBy"]
            }
            this.rows.push(tempValue);
          }
        }

        let temporaryIdList = "";
        let firstTime = true;
        for (let item of temporaryOrderNumberArray) {
          if (firstTime) {
            temporaryIdList += "'" + item + "'";
          } else {
            temporaryIdList += ",'" + item + "'";
          }
          firstTime = false;
        }

        this.serviceClass.allOrdersDetailsByIdList(temporaryIdList).subscribe(
          data => {
            for (let itemDetails of this.rows) {
              for (let item of data) {
                if (item["orderId"] == itemDetails["orderId"]) {
                  if (item["properName"] == "dispatched") {
                    itemDetails["dispatchedDate"] = item["dateAndTime"];
                  }
                  if (item["properName"] == "confirmedWithCOD") {
                    itemDetails["confirmAgent"] = item["employeeEmail"];
                  }
                }
              }
            }
          }
        );

      }
    );
  }

  getUserName(email: any) {
    for (let employee of this.allUsers) {
      if (employee["email"] == email) {
        return employee["name"];
      }
    }
  }

  getConfirmedDate(dataArray: any[], orderId: any) {
    for (let item of dataArray) {
      if (item["orderNumber"] == orderId) {
        if (item["properName"] == "confirmed" || item["properName"] == "confirmedWithCOD") {
          return item["dateAndTime"];
        }
      }
    }
  }


  getDispatchedDate(dataArray: any[], orderId: any) {
    for (let item of dataArray) {
      if (item["orderNumber"] == orderId) {
        if (item["properName"] == "dispatched") {
          return item["dateAndTime"];
        }
      }
    }
  }

  getReturnedDate(dataArray: any[], orderId: any) {
    for (let item of dataArray) {
      if (item["orderNumber"] == orderId) {
        if (item["properName"] == "return") {
          return item["dateAndTime"];
        }
      }
    }
  }
}
